const header = {
    about_rebless_clinic: "About rebless™ Clinic",
    rebless_app: "rebless™ App",
    faq: "FAQ",
    go_to_rebless_clinic: "Go to rebless™ Clinic"
}

export default header;